import styled from 'styled-components';

export const CostInsightsWrapper = styled.section`
  padding: 80px 0;
  background: #fff;
  @media (max-width: 990px) {
    padding: 60px 0;
  }
  @media (max-width: 767px) {
    padding: 40px 0;
  }
`;

export const ScreenshotWrapper = styled.figure`
  max-width: 924px;
  margin: 40px auto 10px;

  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 8px 30px rgba(15, 33, 55, 0.12);
  }

  figcaption {
    margin-top: 12px;
    text-align: center;
    font-size: 14px;
    color: #5d646d;
  }
`;

export const HighlightGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 45px;

  @media (max-width: 990px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const Highlight = styled.div`
  h3 {
    font-size: 17px;
    font-weight: 600;
    color: #0f2137;
    letter-spacing: -0.01em;
    margin: 0 0 10px;
  }
  p {
    font-size: 15px;
    color: #343d48cc;
    line-height: 1.7;
    margin: 0;
  }
`;

export const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 45px;

  @media (max-width: 990px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const ServiceCategory = styled.div`
  background: #f9fbfd;
  border: 1px solid #e2eaf3;
  border-radius: 10px;
  padding: 25px;

  > h3 {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #46679f;
    margin: 0 0 18px;
  }

  dl {
    margin: 0;
  }

  dt {
    font-size: 15px;
    font-weight: 600;
    color: #0f2137;
    margin: 0 0 4px;
  }

  dd {
    font-size: 14px;
    color: #343d48cc;
    line-height: 1.65;
    margin: 0 0 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ChipsLabel = styled.p`
  margin: 45px 0 0;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: #46679f;
`;

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 45px;
`;
